<template>

    <div
        class="bg-primary round"
        v-show="unreadCount > 0"
    >
        {{ unreadCount }}
    </div>

</template>

<script>
export default {
    name: 'unread-message-counter',
    data() {
        return {
            unreadCount: 0,
            _poller: null,
        };
    },
    methods: {
        fetchUnread() {
            // Uses global axios configured in dashboard.js
            if (typeof window.axios === 'undefined') { return; }

            window.axios.get('api/get-user-conversations')
                .then(response => {
                    let count = 0;
                    if (response && response.data && typeof response.data.unreadConversations !== 'undefined') {
                        count = parseInt(response.data.unreadConversations, 10) || 0;
                    }
                    this.unreadCount = count;
                })
                .catch(() => {
                    // Fail silently
                });
        }
    },
    mounted() {
        this.fetchUnread();
        this._poller = setInterval(() => this.fetchUnread(), 60000);
    },
    beforeDestroy() {
        if (this._poller) {
            clearInterval(this._poller);
        }
    }
};
</script>

<style scoped>
.round {
    display: inline-block;
    color: #000;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    text-decoration: none;
    text-align: center;
    padding: 1px 4px 1px 4px;
    margin-left: 1em;
    font-size: 1em;
    min-width: 2em;
}
</style>
